import React from 'react';
import { Avatar } from 'antd';
import VideoCard from '../VideoComponent'
import {
    ProductCard,
    SimpleProductCard,
    HighlightCard,
} from './styled';

const ProductCardComponent = ({ item, theme }) => {
    const cardClassName = theme?.card_style === 'fill-slightly-rounded' ? 'card-fill-slightly-rounded' : 'card-default';
    const buttonClassName = theme?.button_style === 'fill-slightly-rounded' ? 'button-fill-slightly-rounded' : 'button-default';

    // Add this function to handle price display
    const displayPrice = (price) => {
        if (price === undefined || price === null) return null;
        return price === 0 ? 'Free' : `$${price.toFixed(2)}`;
    };

    if (item.cardType === 'button') {
        return (
            <SimpleProductCard key={item.id} theme={theme} className={buttonClassName}>
                <a
                    href={item.url || item.checkoutUrl}
                    className="block__card--pill"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {item.thumbnail && (
                        <span className="block__image--pill">
                            <img
                                src={item.thumbnail || 'https://via.placeholder.com/150'}
                                alt="block image"
                                className="base-preview-image"
                            />
                        </span>
                    )}
                    <div className={`block__content ${!item.thumbnail ? 'centered' : ''}`}>
                        <div className="block__text--pill">{item.text}</div>
                        {item.price !== undefined && (
                            <div className="price-review">
                                <div className="product-price">
                                    <span className="amount">{displayPrice(item.price)}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    {item.thumbnail && <span className="block__spacer"></span>}
                </a>
            </SimpleProductCard>
        );
    }


    if (item.cardType === 'highlight') {
        return (
            <HighlightCard key={item.id} theme={theme} className={cardClassName}>
                <a href={item.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                    <div className="product-content">
                        <img src={item.thumbnail || 'https://via.placeholder.com/150'} alt={item.text} className="highlight-image" />
                        <div className="highlight-gradient">
                            <h3 className="highlight-title">{item.text}</h3>
                        </div>
                    </div>
                </a>
            </HighlightCard>
        );
    }

    if (item.cardType === 'video') {
        return (
            <VideoCard key={item.id} item={item} theme={theme} className={cardClassName} useCarousel={item.useCarousel} />
        );
    }

    // item.cardType === 'spotlight' or 'highlight' buttons
    return (
        <ProductCard key={item.id} theme={theme} className={cardClassName}>
            <div className="product-content">
                <div className="product-image">
                    <Avatar shape="square" size={90} src={item.thumbnail || 'https://via.placeholder.com/150'} />
                </div>
                <div className="product-info">
                    <h3 style={{ color: theme?.card_text_color }}>{item.text}</h3>
                    <p style={{ color: theme?.card_text_color }}>{item.subtitle}</p>
                    {item.price !== undefined && (
                        <div className="product-price">
                            <span className="amount">{displayPrice(item.price)}</span>
                        </div>
                    )}
                </div>
            </div>
            <a href={item.url || item.checkoutUrl} className="product-button" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: theme?.button_color }}>
                <span className="button-text" style={{ color: theme?.button_text_color }}>{item.buttonName || 'Buy Now'}</span>
                <span className="button-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </a>
        </ProductCard>
    );
};

export default ProductCardComponent;